import React from "react";
import { CircleDollarSignIcon, Clock3Icon, DownloadIcon, ShieldCheckIcon } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
const confidenceItems = [{
  icon: ShieldCheckIcon,
  title: "14 días de garantía",
  description: "Según las condiciones informadas."
}, {
  icon: CircleDollarSignIcon,
  title: "Pago único",
  description: "Sin suscripciones."
}, {
  icon: DownloadIcon,
  title: "Acceso inmediato",
  description: "Material 100% digital."
}, {
  icon: Clock3Icon,
  title: "Acceso de por vida",
  description: "Consultalo cuando quieras."
}];
const enterEase = [0.22, 1, 0.36, 1] as const;
export function PurchaseConfidence() {
  const reduceMotion = useReducedMotion();
  return <section className="bg-white py-10 sm:py-14 lg:py-16" data-id="element-295" data-mp="391y1rm76ppsc">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-296" data-mp="n7mo97sxz5g">
        <motion.div className="text-center" initial={reduceMotion ? false : {
        opacity: 0
      }} whileInView={reduceMotion ? undefined : {
        opacity: 1
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.4,
        ease: enterEase
      }} data-id="element-297" data-mp="lms4jlhmg7l">
          <p className="text-[10px] font-bold tracking-[0.15em] text-[#0077e8]" data-id="element-298" data-mp="1pr6rej71ul3i">COMPRA SEGURA</p>
          <h2 className="mt-3 text-[28px] font-extrabold leading-[1.05] tracking-[-0.055em] text-[#091a37] sm:text-4xl" data-id="element-299" data-mp="24f9vfn1j7mpo">Comprá con tranquilidad</h2>
          <p className="mt-2 text-[13px] text-[#657189]" data-id="element-300" data-mp="2df6ffbcz7xee">Tu acceso es simple, inmediato y sin suscripciones.</p>
        </motion.div>

        <div className="relative mt-7 grid grid-cols-2 lg:mt-10 lg:grid-cols-4" data-id="element-301" data-mp="29cjkh1l0dwcz">
          <span aria-hidden="true" className="absolute bottom-0 left-1/2 top-0 w-px bg-[#d7e9f6] lg:hidden" data-id="element-302" data-mp="2ndvyv8kitpwr" />
          <span aria-hidden="true" className="absolute left-0 right-0 top-1/2 h-px bg-[#d7e9f6] lg:hidden" data-id="element-303" data-mp="2idzwtevdw8ju" />
          {confidenceItems.map((item, index) => {
          const Icon = item.icon;
          return <motion.article key={item.title} className={`relative min-h-[116px] px-4 py-5 text-center sm:min-h-[124px] sm:px-6 sm:py-6 lg:min-h-0 lg:px-6 lg:py-0 ${index > 0 ? "lg:border-l lg:border-[#d7e9f6]" : ""}`} initial={reduceMotion ? false : {
            opacity: 0,
            y: 5
          }} whileInView={reduceMotion ? undefined : {
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.25
          }} transition={{
            duration: 0.38,
            delay: 0.1 + index * 0.075,
            ease: enterEase
          }} data-id="element-304" data-mp="o1jqke2l8uez" data-mpi={index}>
                <Icon className="mx-auto h-6 w-6 text-[#0077e8] sm:h-7 sm:w-7" aria-hidden="true" data-id="element-305" data-mp="3bzx3kn0n430c" />
                <h3 className="mt-2.5 text-[14px] font-extrabold leading-[1.15] tracking-[-0.025em] text-[#091a37] sm:text-[15px]" data-id="element-306" data-mp="3gqnaw5smmfxo">{item.title}</h3>
                <p className="mx-auto mt-1.5 max-w-[130px] text-[11px] leading-[1.35] text-[#657189] sm:text-[12px]" data-id="element-307" data-mp="3krz22fr5f97z">{item.description}</p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}